import { proxyCustomElement, HTMLElement, h, Fragment } from '@stencil/core/internal/client';
import { a as setDataTableCellIndicesOnSlotChange } from './cl-data-table.utils.js';
import { d as defineCustomElement$3 } from './cl-data-table-head-cell2.js';
import { d as defineCustomElement$2 } from './cl-icon2.js';

const clDataTableHeadRowCss = ":host(cl-data-table-head-row){background-color:var(--data-table-row-background);display:table-row;position:relative;transition:background-color var(--animation-duration-fast) ease-in-out}:host(cl-data-table-head-row) cl-data-table-head-cell:first-of-type{max-width:-moz-fit-content;max-width:fit-content;padding:0;width:0}@supports not (background: -webkit-named-image(i)){:host(cl-data-table-head-row) cl-data-table-head-cell:first-of-type::after{background-color:var(--data-table-indent-color);border-radius:var(--size-quarter);bottom:0;content:\"\";left:0;position:absolute;top:0;width:var(--border-width)}}@supports (background: -webkit-named-image(i)){:host(cl-data-table-head-row) cl-data-table-head-cell:first-of-type{border-left:var(--border-width) solid var(--data-table-indent-color)}}:host(cl-data-table-head-row) cl-data-table-head-cell:first-of-type ::slotted(*){padding:0 var(--spacing-1) 0 var(--spacing-3) !important}@supports not (background: -webkit-named-image(i)){:host(cl-data-table-head-row)::before{background-color:var(--data-table-border-color);border-radius:var(--size-quarter);bottom:0;content:\"\";height:var(--border-width);left:0;position:absolute;width:100%;}}@supports not (background: -webkit-named-image(i)){:host(cl-data-table-head-row)::after{background-color:var(--data-table-border-color);border-radius:var(--size-quarter);bottom:0;content:\"\";height:var(--border-width);left:0;position:absolute;width:100%;width:0}}";

const ClDataTableHeadRow$1 = /*@__PURE__*/ proxyCustomElement(class ClDataTableHeadRow extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.rowIndex = undefined;
  }
  /**
   * Updates the --data-table-height CSS variable on clDragStart of a table-head-cell element.
   */
  handleDragStart() {
    const table = this.element.closest('cl-data-table');
    const tableHead = table === null || table === void 0 ? void 0 : table.querySelector('cl-data-table-head');
    const tableBody = table === null || table === void 0 ? void 0 : table.querySelector('cl-data-table-body');
    this.element.style.setProperty('--data-table-height', `${tableHead.offsetHeight + tableBody.offsetHeight}px`);
  }
  /**
   * Updates the --data-table-height CSS variable on clDragStart of a table-head-cell element.
   */
  resetTableHeadDragStyles() {
    const children = this.element.children;
    for (let index = 0; index < children.length; index++) {
      const dataTableHeadCell = children[index];
      dataTableHeadCell.classList.remove('dragging', 'drop-overlay', 'drop-overlay--hover', 'drop-overlay--hover--left', 'drop-overlay--hover--right');
    }
  }
  render() {
    return (h(Fragment, null, h("cl-data-table-head-cell", null, h("slot", { name: 'action' })), h("slot", { onSlotchange: setDataTableCellIndicesOnSlotChange })));
  }
  get element() { return this; }
  static get style() { return clDataTableHeadRowCss; }
}, [1, "cl-data-table-head-row", {
    "rowIndex": [2, "row-index"]
  }, [[0, "clDragStart", "handleDragStart"], [0, "clDragEnd", "resetTableHeadDragStyles"], [0, "clDrop", "resetTableHeadDragStyles"]]]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["cl-data-table-head-row", "cl-data-table-head-cell", "cl-icon"];
  components.forEach(tagName => { switch (tagName) {
    case "cl-data-table-head-row":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ClDataTableHeadRow$1);
      }
      break;
    case "cl-data-table-head-cell":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "cl-icon":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const ClDataTableHeadRow = ClDataTableHeadRow$1;
const defineCustomElement = defineCustomElement$1;

export { ClDataTableHeadRow, defineCustomElement };

//# sourceMappingURL=cl-data-table-head-row.js.map